module.exports = __webpack_public_path__ + "img/icon_zs.7530006a.png";